import obliqDarkLogo from "@/assets/obliq-dark.png";
import obliqLightLogo from "@/assets/obliq-light.svg";

type Theme = "light" | "dark";

interface BrandLogoProps {
	theme: Theme;
	className?: string;
}

export function BrandLogo({ theme, className = "" }: BrandLogoProps) {
	const logoSrc = theme === "dark" ? obliqDarkLogo : obliqLightLogo;

	return (
		<span className={`brand-logo${className ? ` ${className}` : ""}`} aria-label="OBLIQ">
			<img className="brand-logo-mark" src={logoSrc} alt="" />
			<span className="brand-logo-text">OBLIQ</span>
		</span>
	);
}
